
import { motion, useScroll } from "framer-motion";

/**
 * Thin gold progress bar fixed at the very top of the viewport,
 * showing scroll progress on detail pages.
 */
export default function ReadingProgress() {
  const { scrollYProgress } = useScroll();

  return (
    <motion.div
      style={{ scaleX: scrollYProgress, transformOrigin: "0%" }}
      className="fixed top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[var(--color-gold)] to-[var(--color-gold-light)] z-[60]"
    />
  );
}
